export enum VIEW_TYPES {
  LIST = 'list',
  TREE = 'tree',
  BRAND_GRID = 'brand_grid',
  OTHER_GRID = 'other_grid',
  SLIDER = 'slider',
  CUSTOM = 'custom',
}

export const TEXTS = {
  FILTERS: 'Filters',
};

export const FILTER_TEXT_HEIGHT = 24;
